// src/pages/bepalingen/bepalingen.tsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './bepalingen.module.scss';

export default function Bepalingen() {
    return (
        <div className={styles.container}>
            <Outlet />
        </div>
    );
}